

<!-- trigger -->
<span #trigPopover class="appt-ellipsis" (click)="toggle()">
    <mat-icon [style.color]="color" #trigPopoverIcon >more_vert</mat-icon></span>
<!-- popover -->
<div #popoverC class="p-2 mt-5 popover" [class.active]="isActive">
    <ng-content></ng-content>
</div>